export default __webpack_public_path__ + "static/media/BOhero.5ad75cf3.jpg";